import { render, staticRenderFns } from "./CreateMyBusinessAddress.vue?vue&type=template&id=b5194692&"
import script from "./CreateMyBusinessAddress.vue?vue&type=script&lang=js&"
export * from "./CreateMyBusinessAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports